import { useState } from 'react';
import i18n from '../../i18n';
import type { SharePointLocation } from '../../data/types';
import { LocationPicker } from './LocationPicker';

interface ChooseLocationDialogProps {
  initialLocation: SharePointLocation | null;
  onChoose: (location: SharePointLocation) => void;
  close: () => void;
}

export function ChooseLocationDialog({ initialLocation, onChoose, close }: ChooseLocationDialogProps) {
  const [location, setLocation] = useState(initialLocation);

  return (
    <div className="flex flex-col gap-4">
      <LocationPicker initialLocation={initialLocation} onChange={setLocation} allowOneDrive={false} />
      <div className="flex justify-end border-t border-border pt-4">
        <button
          type="button"
          disabled={!location}
          onClick={() => {
            if (!location) return;
            onChoose(location);
            close();
          }}
          className="inline-flex items-center justify-center gap-2 rounded bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground ring-1 ring-primary-hover transition hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-60"
        >
          {i18n.t('sharePoint.choose.confirm')}
        </button>
      </div>
    </div>
  );
}
